import { render } from "./LotteryRulesModal.vue?vue&type=template&id=3d8902a8&scoped=true"
import script from "./LotteryRulesModal.vue?vue&type=script&lang=js"
export * from "./LotteryRulesModal.vue?vue&type=script&lang=js"

import "./LotteryRulesModal.vue?vue&type=style&index=0&id=3d8902a8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8902a8"]])

export default __exports__